import './styles.css';

import React, {Component, Fragment} from 'react';
import Content from "../../content/Content";
import { Link } from "react-router-dom";



class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            width: window.innerWidth
        }

    }

    componentDidMount () {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth });
    };


    render() {

        let customStyleh4 = null, customStyleFMiddle = null, customStyleFMList = null, customStyleFaStack = null;

        if(this.state.width < 990) {
            customStyleh4 = {
                font: 'normal 14px/40px GillSans Regular'
            };
            customStyleFMiddle = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '40px',
                background: '#191919',
                color: '#FFF'
            };
            customStyleFMList = {
                marginRight: '10px',
                font: 'normal 12px/40px GillSans Regular'
            };
            customStyleFaStack = {
                fontSize: '12px'
            };

        }

        return (
            <div style={{background: '#191919'}}>
                <div className="footer">

                    <div className="f-left">
                        <h4 style={customStyleh4}>{Content.FOOTER.CREWKARMA}</h4>
                    </div>

                    {
                        this.state.width > 990 ?
                            <div className="f-middle">
                                <div className="fm-pp"><Link to="/information/privacy-policy">{Content.FOOTER.PRIVACY_POLICY}</Link></div>
                                <div className="fm-tnc"><Link to="/information/terms-and-conditions">{Content.FOOTER.TERMS_AND_CONDITIONS}</Link></div>
                                <div className="fm-faq"><Link to="/information/faq">{Content.FOOTER.FAQ}</Link></div>
                            </div>
                            :
                            null
                    }


                    <div className="f-right">
                    <span style={customStyleFaStack} className="fa-stack fa-lg">
                        <a href="https://www.facebook.com/crewkarmanetworks/" target="_blank">
                            <i className="fa fa-circle fa-stack-2x"></i>
                            <i className="fa fa-facebook fa-stack-1x fa-inverse"></i>
                        </a>
                    </span>
                        <span style={customStyleFaStack} className="fa-stack fa-lg">
                        <a href="https://www.linkedin.com/company/3703120/" target="_blank">
                            <i className="fa fa-circle fa-stack-2x"></i>
                            <i className="fa fa-linkedin fa-stack-1x fa-inverse"></i>
                        </a>
                    </span>
                        <span style={customStyleFaStack} className="fa-stack fa-lg">
                        <a href="https://twitter.com/TheCrewKarma" target="_blank">
                            <i className="fa fa-circle fa-stack-2x"></i>
                            <i className="fa fa-twitter fa-stack-1x fa-inverse"></i>
                        </a>
                    </span>
                    </div>


                </div>

                {
                    this.state.width < 990 ?
                        <div style={customStyleFMiddle} className="f-middle">
                            <div style={customStyleFMList} className="fm-pp"><Link to="/information/privacy-policy">{Content.FOOTER.PRIVACY_POLICY}</Link></div>
                            <div style={customStyleFMList} className="fm-tnc"><Link to="/information/terms-and-conditions">{Content.FOOTER.TERMS_AND_CONDITIONS}</Link></div>
                            <div style={customStyleFMList} className="fm-faq"><Link to="/information/faq">{Content.FOOTER.FAQ}</Link></div>
                        </div>
                        :
                        null
                }
            </div>
        )

    }

}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js